const historyLogUserAction = {
	create: 1,
	update: 2,
	delete: 3,
};

const historyLogSource = {
	fulfillmentOrder: 1,
	product: 2,
	marketplaceOrder: 3,
	receiving: 4,
};

export { historyLogUserAction, historyLogSource };



// WEBPACK FOOTER //
// ./src/common/constants/historyLogConstants.js